import { render, staticRenderFns } from "./EstadoFacturaCombobox.vue?vue&type=template&id=2888617f&scoped=true"
import script from "./EstadoFacturaCombobox.vue?vue&type=script&lang=js"
export * from "./EstadoFacturaCombobox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2888617f",
  null
  
)

export default component.exports